export const DOMAIN_URL = import.meta.env.VITE_DOMAIN_URL;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const INVOICE_URL = import.meta.env.VITE_INVOICE_URL;
export const IMAGE_URL = import.meta.env.VITE_IMAGE_URL;
export const DOMAIN_NAME = import.meta.env.VITE_DOMAIN_NAME;
export const DEFAULT_PROFILE_IMAGE = import.meta.env.VITE_DEFAULT_PROFILE_IMAGE;
export const ADMIN_DASHBOARD_URL = import.meta.env.VITE_ADMIN_DASHBOARD_URL;
export const MEDGAMMA_API_URL = import.meta.env.VITE_MEDGEMMA_API_URL;
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;